module.exports = __webpack_public_path__ + "img/edit.b65a1277.svg";